<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tC9fIA/cover.jpg?1700404658651" alt="This image is the cover for the book Last Breath, Nightmare Hall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Breath, Nightmare Hall
      </h1>
      <p class="bookDescription body article font2">
        <b>College can really drive a person crazy . . .</b><i><br/>Am I losing my mind?</i><br/>That’s the question that haunts Salem University student Cassidy Kirk when weird things start happening to her.<i><br/></i><br/>A paper she slaved over for Psych 101 disappears. Cash vanishes from her bag. She shows up for a party that’s not happening until <i>next </i>week. Then she’s almost run down by a black car with tinted windows that no one else sees.<br/>Is she going crazy? Or is someone trying to kill her? As things go from bad to much, much worse, Cassidy starts to suspect that she has an enemy out there. With time running out, she must figure out who’s out to get her and why—or the next breath she takes may be her last.<br/>This ebook features an illustrated biography of Diane Hoh including rare photos and never-before-seen documents from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Hoh
      </h2>
      
      <p class="authorDescription body article">Diane Hoh (b. 1937) is a bestselling author of young adult fiction. Born in Warren, Pennsylvania, Hoh began her first novel, <i>Loving That O&rsquo;Connor Boy</i> (1985), after seeing an ad in a publishing trade magazine requesting submissions for a line of young adult fiction.&#160;After contributing novels to two popular series, Cheerleaders and the Girls of Canby Hall, Hoh found great success writing thrillers, beginning with <i>Funhouse</i> (1990), a Point Horror novel that became a national bestseller. Following its success, Hoh created the Nightmare Hall series, whose twenty-nine installments chronicle a university plagued by dark secrets, and the seven-volume Med Center series, about the challenges and mysteries in a Massachusetts hospital. In 1998, Hoh had a runaway hit with <i>Titanic: The Long Night</i> and <i>Remembering the Titanic</i>, a pair of novels about two couples&rsquo; escape from the doomed ocean liner. She now lives and writes in Austin. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e616d11